import { useEffect } from "react";

import { useIsMobile } from "@/components/hooks/use-mobile";

export function WhatPeopleAreSaying() {
  const isMobile = useIsMobile();
  const limit = isMobile ? 3 : 6;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { data } = event as {
        data: [string, { id: string; height: number }];
      };

      if (!data || !Array.isArray(data)) return;

      // We'll send an event with the name 'setHeight' and the data will be a
      // object with the 'id' of the iframe and the 'height' of the iframe.
      const [eventName, eventData] = data;

      switch (eventName) {
        case "setHeight": {
          const iframes = document.getElementsByTagName("iframe");

          for (const iframe of iframes) {
            if (iframe.id === eventData.id) {
              iframe.style.height = eventData.height + "px";
              break;
            }
          }
        }
      }
    };

    window.addEventListener("message", handleMessage, false);

    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, [limit]);

  return (
    // eslint-disable-next-line @eslint-react/dom/no-missing-iframe-sandbox
    <iframe
      src={`/feeds/embed/9997?mode=masonry-click&frameless=1&limit=${limit}`}
      className="w-full"
      title="posts about graze.social"
    />
  );
}
